<template>
  <section>
    <section class="section-disinfection">
      <div class="row">
        <div class="col-lg-6 offset-lg-3">
          <request-form :serviceId="24"/>
        </div>
      </div>
    </section>

    <section class="section-padding section-padding-gray">
      <div class="row">
        <div class="col-md-2">&nbsp;</div>
        <div class="col-md-8 col-12">
          <h2>บริการพ่นฆ่าเชื้อโรค บริการใหม่จาก BeNeat</h2>
          <p>ให้ทุกพื้นที่ในบ้านของคุณปลอดภัยจากเชื้อโรคตัวร้าย ด้วยบริการฉีดพ่นกำจัดเชื้อโรค ไวรัส แบคทีเรีย และเชื้อรา จากสารสกัดจากธรรมชาติที่ BeNeat คัดสรรมาเป็นอย่างดี สามารถกำจัดเชื้อโรคได้ถึง 99.99% การันตีด้วยรางวัลมากมายทั้งในและต่างประเทศมากมายและได้รับ<span class="text-success">มาตรฐานทั้ง FDA (อย.) มอก. ECOCERT, NSF, SGS ฉลากเขียว</span></p>
          <h2><span class="text-success">ในราคาเริ่มต้นเพียง 2,140 บาทเท่านั้น</span></h2>
          <p><span class="text-orange">*อัตราค่าบริการจะคิดตามพื้นที่ เปิดให้บริการเฉพาะกรุงเทพและปริมณฆลนะคะ</span></p>
          <p><b>การพ่นน้ำยากำจัดเชื้อโรค</b> คือ การให้บริการฉีดพ่นน้ำยากำจัดเชื้อแบคทีเรีย เชื้อรา และไวรัส ด้วยทีมงานมืออาชีพที่มาพร้อมกับเครื่องพ่นน้ำยาฆ่าเชื้อพิเศษที่นำเข้ามาจากต่างประเทศ สามารถพ่นละอองฝอยได้เล็กถึง 10 ไมครอน สามารถจับกับเชื้อโรคได้อย่างมีประสิทธิภาพและไม่ทำให้ผนัง พื้นผิว วัสดุ ตลอดจนเฟอร์นิเจอร์ของคุณเสียหาย แต่หากละอองนั้นใหญ่เกินไปจะไม่สามารถเกาะกับพื้นผิวได้นานและไม่ทั่วถึงทำให้การกำจัดเชื้อโรคนั้นได้ผลได้ไม่ดีค่ะ</p>
          <h3><span class="text-success">Germ killer Bio Disinfectant</span></h3>
          <p>น้ำยาฆ่าเชื้อโรค แบคทีเรีย เชื้อรา เชื้อไวรัสได้ถึง 99.99%</p>
          <p>ผลิตภัณฑ์ของบริษัท คีนน์ จำกัด</p>
          <p>ได้รับการรับรองจากสถาบันวิจัยชั้นนำทั้งในประเทศและระดับสากล</p>
          <p>สามารถย่อยสลายได้เองตามธรรมชาติ โดยไม่ส่งผลกระทบต่อระบบนิเวศน์ และสิ่งแวดล้อม ฉีดพ่นแล้วเช็ดออกไม่เป็นอันตรายทั้งต่อคน และสัตว์เลี้ยง ประกอบด้วยสารสกัดจากพืช และสารประกอบออกไซด์ สามารถขจัดคราบเลือด คราบไขมัน คราบที่เกิดจากเชื้อรา และคราบตะกรันที่เกิดจากสารอินทรีย์ได้ดี ช่วยย่อยสลายของเสียได้อย่างรวดเร็ว ในขณะเดียวกันยังสามารถดับกลิ่นได้ไปในเวลาเดียวกัน ย่อยสลายได้เองตามธรรมชาติ และไม่ส่งผลกระทบต่อสิ่งแวดล้อม เป็นน้ำยาฆ่าเชื้อโรคคุณภาพสูงที่ได้รับการยอมรับในระดับสากล ใช้กันอย่างแพร่หลายในหน่วยงานราชการ และแม้แต่<b>สายการบินชั้นนำยังเลือกใช้</b>เพื่อกำจัดเชื้อโรคภายในห้องโดยสารอีกด้วยค่ะ</p>
          <div>
            <img src="https://story.beneat.co/wp-content/uploads/2020/04/2563-04-08_11h07_54-e1586327629501-640x221.png" class="img-fluid" alt="">
            <img src="https://story.beneat.co/wp-content/uploads/2020/04/2563-04-08_11h08_08-640x202.png" class="img-fluid" alt="">
          </div>
          <div class="mt-4">
            <h4 class="text-orange">มาตรฐานรับรอง</h4>
            <img src="https://story.beneat.co/wp-content/uploads/2020/04/2563-04-08_13h46_21-e1586330396164.png" height="120" alt="">
            <img src="https://story.beneat.co/wp-content/uploads/2020/04/2563-04-08_13h48_05-150x150.png" height="120" alt="">
            <img src="https://story.beneat.co/wp-content/uploads/2020/04/SGS_logo_logotype-e1586329536913.png" height="120" alt="">
            <img src="https://story.beneat.co/wp-content/uploads/2020/04/unnamed-1-e1586330171470.jpg" height="120" alt="">
            <img src="https://story.beneat.co/wp-content/uploads/2020/04/unnamed-e1586330204656.jpg" height="120" alt="">
            <img src="https://story.beneat.co/wp-content/uploads/2020/04/2563-04-08_13h46_47-e1586330237905.png" height="120" alt="">
            <img src="https://story.beneat.co/wp-content/uploads/2020/04/2563-04-08_13h46_59-e1586330261438.png" height="120" alt="">
            <img src="https://story.beneat.co/wp-content/uploads/2020/04/unnamed-e1586330271913.png" height="120" alt="">
            <img src="https://story.beneat.co/wp-content/uploads/2020/04/nsf-logo-e1586330459934.png" height="120" alt="">
          </div>
        </div>
        <div class="col-md-2">&nbsp;</div>
      </div>
    </section>
  </section>
</template>

<script>
  import RequestForm from '../serviceRequest/RequestForm'

  export default {
    components: {
      RequestForm
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/serviceRequest/DisinfectantCleaning.vue